import { create } from 'zustand';

const useCustomerInfoOrders = create((set) => ({
  schedularDate: {},
  selectedStatus: "ALL",
  customerALLOrdersData: [],
  statusTotalData: [],
  sumOfGrandTotal: 0,
  sumOfOrderCount: 0,

  setSchedularDate: (val) => set({ schedularDate: val }),
  setSelectedStatus: (val) => set({ selectedStatus: val }),
  setCustomerALLOrdersData: (val) => set({ customerALLOrdersData: val }),
  setStatusTotalData: (val) => set({ statusTotalData: val }),
  setSumOfGrandTotal: (val) => set({ sumOfGrandTotal: val }),
  setSumOfOrderCount: (val) => set({ sumOfOrderCount: val }),
}));
export default useCustomerInfoOrders;
